import React from 'react';
import classnames from 'classnames';
import { toast } from '@platform/api';
import {
    Sidebox as SideBox,
    Input,
    Tooltip,
    ButtonGroup,
    Button,
    HotKeys,
    DndDropContext,
} from '@platform/base';
import { getViewportBoundary } from '../../utils';
import { setLocalStorageColumnsWidth } from '../../adapter/utils/handleProps';
import { getRawColumns, setColumns, resetColumns } from './requestUtil';
import './index.less';
import { leftDnd, rightDnd } from './dnd';
class ColSetting extends React.Component {
    constructor(props) {
        super(props);
        let { store, id } = this.props;
        this.state = {
            show: false,
            leftKeyword: '',
            rightKeyword: '',
            rawColumns: [], // 左边的
            viewColumnKeys: [], // 右边的
            rawMap: {}, // 左边的key => col映射
            viewMap: {}, // 右边的key => col映射
            subModalShow: false, // 列宽设置弹窗
            changedColumn: {}, // 正在进行列宽设置的列 { key, width }
            tableId: store.getFlatInfo?.()?.tableId || id, //切换主子表

        };
        this.leftDragIndex = -1; // 记录左边拖拽的index
        this.rightDragIndex = -1; //记录右边拖拽的index
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        let { id } = this.props;
        // 改变显示为true时，请求数据
        if (!this.props.show && nextProps.show) {
            this.renderContent(nextProps.currentId || id);
            this.setState({
                show: true,
                leftKeyword: '',
                rightKeyword: '',
            });
        } else if (this.props.show && !nextProps.show) {
            this.setState({ show: false });
        }
    }
    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyDown);
    }

    //

    render() {
        let { leftKeyword, rightKeyword, show } = this.state;
        let { locale } = this.props;
        return (<>
            <SideBox
                title={this.renderTitle()}
                show={show}
                mask={true}
                maskClose={this.handleClose}
                keyboard={true}
                width={800}
                onClose={this.handleClose}
                className="set-table-column-drawer"
            >
                {<HotKeys
                    keyMap={{
                        handleSave: 'alt+Y',
                        handleClose: 'alt+N',
                    }}
                    handlers={{
                        handleClose: this.handleClose,
                        handleSave: () => this.handleSave('column_set_success', true),
                    }}
                    className="colSetting-hotkeys-wrapper"
                    focused={true}
                    attach={document.body}
                    display="inline"
                />}
                <div className='table-column-content'>
                    <div className='table-column-content-left-box'>
                        <h3 className="table-column-content-title">
                            <span style={{ flex: 'none' }}>
                                {locale['menu_to_add'] /*待添加*/}
                            </span>
                            <span className="table-column-content-title-search">
                                <Input
                                    fieldid={'column-setting-left'}
                                    value={leftKeyword}
                                    type="search"
                                    placeholder={locale['menu_input_holder'] /*请输入字段名称*/}
                                    onChange={value => this.setState({ leftKeyword: value }, () => {
                                        let findCol = document.querySelector('.select-by-keyword');
                                        if (findCol) {
                                            document.querySelector('.table-column-content-left').scrollTop = findCol.offsetTop;
                                        }
                                    })}
                                    clearSearch={() => this.setState({ leftKeyword: '' })}
                                />
                            </span>
                        </h3>
                        <ul className="table-column-content-left">
                            {this.renderLeftList()}
                        </ul>
                    </div>
                    <div className="table-column-content-right-box">
                        <h3 className="table-column-content-title">
                            <span style={{ flex: 'none' }}>
                                {locale['menu_to_added'] /*已添加*/}
                            </span>
                            <span className="table-column-content-title-search">
                                <Input
                                    fieldid={'column-setting-right'}
                                    value={rightKeyword}
                                    placeholder={locale['menu_input_holder'] /*请输入字段名称*/}
                                    type="search"
                                    onChange={value => {
                                        this.setState({ rightKeyword: value });
                                    }}
                                    clearSearch={() => this.setState({ rightKeyword: '' })}
                                />
                            </span>
                        </h3>
                        <div className="table-column-content-right">
                            {this.renderRightList()}
                        </div>
                    </div>
                </div>
            </SideBox>
        </>
        );
    }

    renderContent = (currentId, callBack) => {
        let { id, relationMetaId } = this.props;
        let tableId = relationMetaId || currentId || this.props.currentId || id;
        // 优化显示效果，否则取消后第二次进来用的是上一次的数据
        this.setState({
            viewColumnKeys: [], // 右边
            rawColumns: [], // 左边
            viewMap: {},
            rawMap: {},
        }, () => {
            const { store, id } = this.props;
            getRawColumns(store, id).then(res => {
                if (res.success) {
                    let columnsWidth = store.getColumnsWidth(),
                        viewMap = {},
                        rawMap = {},
                        viewColumnKeys = res.data[1][tableId].items.map((col, index) => {
                            let visibleFromStore = store.getColumnProps(col.attrcode, 'visible'); //领域传来的visible
                            let renderVisible = col.visible;
                            if (!visibleFromStore) { //领域设置不显示，则列设置不显示
                                renderVisible = false;
                            }
                            col = {
                                ...col,
                                key: col.attrcode,
                                ...store.getColumnProps(col.attrcode),
                                visible: renderVisible,
                                isModifyVisible: col.visible == !store.getColumnProps(col.attrcode, 'visible'), //领域改过visible
                                label: col.label,
                                width: String(columnsWidth?.[col.attrcode] ?? store.getColumnProps(col.attrcode, 'width')),
                                _index: index,
                                required: store.getColumnProps(col.attrcode, 'required'), // 后台数据错误
                                // required: col.require ?? col.required, // 后台数据错误
                            };
                            viewMap[col.key] = col;
                            return col.key;
                        }),
                        rawColumns = res.data[0].areas[tableId].items
                            .map(col => {
                                let visibleCol = store.getColumnProps(col.code),
                                    { visible, islock, width, ...others } = visibleCol;
                                Object.assign(col, { ...others });
                                col.key = col.code;
                                rawMap[col.key] = col;
                                return col;
                            });

                    this.setState({
                        viewColumnKeys, // 右边
                        rawColumns, // 左边
                        viewMap,
                        rawMap,
                        tableId: tableId,
                    }, () => {
                        callBack?.();
                    });
                }
            }).catch(err => {
                let errMsg = JSON.parse(err.message);
                toast({
                    color: 'warning',
                    content: errMsg,
                    mark: 'lock-tip',
                });
            });
        });
    }
    renderTitle = () => {
        let { locale } = this.props;
        return (
            <div className="set-table-column-drawer-header">
                <h3 className="title">
                    {locale['menu_column_setting'] /*列表设置*/}
                    <Tooltip
                        placement="rightTop"
                        className='col-setting-tips'
                        overlay={<div className='col-setting-tips-overlay'>
                            <p>{locale['table_tips'] /*提示*/}：</p>
                            <p>{locale['menu_tip1'] /*1. 点击字段名称右侧的*/}
                                <i className='icon iconfont icon-ncc-sq' />
                                {locale['and'] /*或*/}
                                <i className='iconfont icon-shanchu4' />
                                {locale['menu_tip2'] /*，控制该字段的显示或隐藏；*/}
                            </p>
                            <p>{locale['menu_tip3'] /*2.调序：拖动“已添加”区域字段，且按“之”字顺序展示；*/}
                            </p>
                            <p>{locale['menu_tip5']?.split('$$$')?.[0] /*3. 点击*/}
                                <i className='iconfont icon-weisuoding' />
                                {locale['menu_tip5']?.split('$$$')?.[1] /*冻结列的位置，如果冻结过多字段，会导致表格不能滚动。*/}
                            </p>
                        </div>}
                    >
                        <i className='iconfont icon-bangzhutishi  icon-help' />
                    </Tooltip >
                </h3>
                <div className="header-btn">
                    <ButtonGroup>
                        <Tooltip
                            placement="bottom"
                            inverse
                            overlay={locale['table_ok_hover']/*保存*/}
                            trigger='hover'
                            className="model-helper-overlay"
                        >
                            <Button
                                colors='primary'
                                onClick={() => this.handleSave('column_set_success', true)}
                                className="button-primary"
                            >
                                {locale['table_ok']/*保存*/}(<span style={{ textDecoration: 'underline' }}>Y</span>)
                            </Button>
                        </Tooltip>

                        <Button
                            onClick={this.handleReset}
                        >{locale['table0031'] /*重置字段*/}</Button>
                    </ButtonGroup>
                    <Tooltip
                        placement="bottom"
                        inverse
                        overlay={locale['table_cancel_hover']/*取消*/}
                        trigger='hover'
                        className="model-helper-overlay"
                    >
                        <Button className="cancel-btn" onClick={this.handleClose}>
                            {locale['table_cancel']/*取消*/}(<span style={{ textDecoration: 'underline' }}>N</span>)
                        </Button>
                    </Tooltip>
                </div>
            </div>
        );
    }

    updateLeftDragIndex = index => {
        this.leftDragIndex = index;
    }
    updateRightDragIndex = index => {
        this.rightDragIndex = index;
    }

    renderLeftList = () => {
        let { hiddenLeftItem, _runContext } = this.props,
            { leftKeyword, viewColumnKeys, viewMap, rawColumns } = this.state,
            visibleColumns = this.getViewColumns();
        let { locale, store } = this.props;
        let status = store.getStatus();
        const Dnd = DndDropContext(leftDnd);

        // 模板上可显示，实际不显示的列
        // TODO 看下问题NCC-43188 可能需要在这里加上columns里的changeMetaCol=true的列
        rawColumns = rawColumns.filter(col =>
            col.visible && !viewMap[col.key]?.visible && !hiddenLeftItem?.includes(col.key),
        );
        const leftList = rawColumns.map(col =>
            <li
                className={classnames(
                    'show-column',
                    'left-column-dnd',
                    { 'select-by-keyword': leftKeyword && col.label?.includes(leftKeyword) },
                )}
                key={col.key}
                draggable={true}
            >
                {col.required && status !== 'browse' && <i className='unselected-mark-icon iconfont icon-xinghao'></i>}

                <span className="label">{col.label}</span>
                <Tooltip
                    placement="top"
                    overlay={locale['add'] /*添加*/}
                    delayHide={1}
                    delayShow={1000}
                >
                    <i
                        className="icon iconfont icon-ncc-sq"
                        onClick={() => {
                            // 改变visible 且添加到队尾 要保证customer列在最后
                            viewMap[col.key].visible = true;
                            this.setState({ viewMap });

                            this.moveColumns(viewMap[col.key]._index, viewColumnKeys.length - 1);
                        }}
                    />
                </Tooltip>
                <Tooltip
                    placement="top"
                    overlay={locale['lock'] /*锁定*/}
                    delayHide={1}
                    delayShow={1000}
                >
                    <i
                        className="icon iconfont icon-weisuoding"
                        onClick={() => {
                            // 添加到最后一个锁定的列的后面（如果没有已锁定的，则作为第一个）
                            // viewIndex
                            let lastLockedIndex = -1;
                            for (let i = visibleColumns.length - 1; i >= 0; i--) {
                                if (visibleColumns[i].islock) {
                                    lastLockedIndex = i;
                                    break;
                                }
                            }

                            viewMap[col.key].visible = true;
                            this.setState({ viewMap });

                            // 有锁定列，插到锁定列后面，否则插到第一位
                            this.moveColumns(viewMap[col.key]._index, lastLockedIndex > -1 ? visibleColumns[lastLockedIndex]._index + 1 : 0);

                            requestAnimationFrame(() => {
                                // getMaxLockColumnIndex 依赖 moveColumns 中 setState 后的数据
                                if (lastLockedIndex + 1 > this.getMaxLockColumnIndex()) {
                                    toast({
                                        // duration: Infinity,
                                        color: 'warning',
                                        content: locale['table_colseting_tip14'] /*字段过多，无法冻结*/,
                                        mark: 'lock-tip',
                                    });
                                    return;
                                }

                                viewMap[col.key].islock = true;
                                viewMap[col.key].resizable = true;
                                this.setState({ viewMap });
                            });
                        }}
                    />
                </Tooltip>
            </li>,
        );
        return <Dnd
            list={leftList}
            _runContext={_runContext}
            updateDragIndex={this.updateLeftDragIndex}
        />;
    }

    renderRightList = () => {
        let { rightKeyword, viewMap } = this.state,
            visibleColumns = this.getViewColumns();
        let { locale, store, pageScope, _runContext } = this.props;
        let status = store.getStatus();
        let { isWidget = false } = store.getConfig() ?? {};
        const Dnd = DndDropContext(rightDnd);
        if (!visibleColumns.length) { return null; }

        let list = visibleColumns.map((col, index) =>
            <div key={col.key} draggable={!col.islock} className={classnames(
                "show-column",
                { 'select-by-keyword': rightKeyword && col.label?.includes(rightKeyword) },
            )}>
                {col.required && <i className='unselected-mark-icon iconfont icon-xinghao'></i>}
                <span className="label">{col.label}</span>
                {(!col.islock && !col.required && !pageScope.isFromApproveCenter()) && <Tooltip
                    placement="top"
                    overlay={locale['hide'] /*隐藏*/}
                    delayHide={1}
                    delayShow={1000}
                >
                    <i
                        className={classnames("icon iconfont icon-shenpibohui")}
                        onClick={() => this.hiddenCol(col)}
                    />
                </Tooltip>}
                {!col.islock && <Tooltip
                    placement="top"
                    overlay={locale['lock'] /*锁定*/}
                    delayHide={1}
                    delayShow={1000}
                >
                    <i
                        className="icon iconfont icon-weisuoding"
                        onClick={() => this.handleRightLockCol(index)}
                    />
                </Tooltip>}
                {/* 锁定的数据只有最后一个有解锁图标 */}
                {col.islock && !visibleColumns[index + 1]?.islock &&
                    <Tooltip
                        placement="top"
                        overlay={locale['unlock'] /*解锁*/}
                        delayHide={1}
                        delayShow={1000}
                    >
                        <i
                            className="icon iconfont icon-suoding"
                            onClick={() => this.handleRightUnLockCol(index)}
                        />
                    </Tooltip>}
            </div>,
        );

        return <Dnd
            list={list}
            onStop={this.handleDragComplete}
            isWidget={isWidget}
            leftDragIndex={this.leftDragIndex}
            updateDragIndex={this.updateRightDragIndex}
            _runContext={_runContext}
        />;
    }

    transformToIndex = (col, visibleColumns) => {
        let index = 0;
        for (let i = 0; i < visibleColumns.length; i++) {
            if (visibleColumns[i].key === col.key) {
                index = i;
                break;
            }
        }
        return index;
    }

    hiddenCol = (col, saveTip) => {
        let { viewMap } = this.state,
            { locale } = this.props;

        viewMap[col.key].visible = false;

        if (Object.values(viewMap).every(e => !e.visible)) {
            viewMap[col.key].visible = true;
            toast({ content: locale['table_colseting_tip15'] /* 请至少保留一个字段 */, color: 'warning' });
            return;
        } else {
            viewMap[col.key].islock = false;
            this.setState({ viewMap });
            saveTip && this.handleSave(saveTip);
        }

    }

    handleRightLockCol = (index, saveTip) => { //useFieldSetting文件通过获取实例也用到了这个方法
        let { locale } = this.props;
        let visibleColumns = this.getViewColumns();
        if (typeof index === "object") {
            index = this.transformToIndex(index, visibleColumns);
        }
        if (index > this.getMaxLockColumnIndex()) {
            // 判断锁定个数是否超过了限制
            toast({
                // duration: Infinity,
                color: 'warning',
                content: locale['table_colseting_tip14'] /*字段过多，无法冻结*/,
                mark: 'lock-tip',
            });
            return;
        }

        // 锁定要把前面的都锁定
        for (let i = 0; i <= index; i++) {
            visibleColumns[i].islock = true;
            // visibleColumns[i].resizable = true; 先放开，允许拖拽 
        }
        this.forceUpdate();
        saveTip && this.handleSave(saveTip);
    }
    handleRightUnLockCol = (index, saveTip) => {
        let { viewMap } = this.state;
        let visibleColumns = this.getViewColumns();
        if (typeof index === "object") {
            index = this.transformToIndex(index, visibleColumns);
        }
        // 要把前面所有的都解锁
        for (let i = 0; i <= index; i++) {
            viewMap[visibleColumns[i].key].islock = false;
            viewMap[visibleColumns[i].key].resizable = true;
        }
        this.setState({ viewMap });
        saveTip && this.handleSave(saveTip);
    }
    // 同步state.viewColumns到props.columns
    updatePropColumns = () => {
        let { store } = this.props,
            { viewMap, tableId } = this.state,
            meta = store.getMeta(),
            lockColumns = [],
            normalColumns = [];

        meta[tableId].items
            .sort((colA, colB) => viewMap[colA.attrcode] && viewMap[colB.attrcode] ? viewMap[colA.attrcode]._index - viewMap[colB.attrcode]._index : 0)
            .forEach(col => {
                if (viewMap[col.attrcode]?.isModifyVisible) { //领域修改过visible属性，按领域的来
                    col = { ...col, ...store.getColumnProps(col.attrcode) };
                } else {
                    col = { ...col, ...viewMap[col.attrcode] };
                }
                if (col.islock) {
                    lockColumns.push(col);
                } else {
                    normalColumns.push(col);
                }
            });
        meta[tableId].items = lockColumns.concat(normalColumns);
        store.setMeta(meta, tableId);
    }

    handleClose = () => {
        this.props.onClose?.();
        this.setState({ leftKeyword: '', rightKeyword: '' });
    }

    handleDragComplete = destinationIndex => {
        let { rawColumns, viewMap } = this.state;
        let { rightDragIndex, leftDragIndex } = this;
        let { hiddenLeftItem } = this.props;
        let startCol, endCol, startColIndex, endColIndex, columns, visibleColumns;
        if (rightDragIndex == -1) { //拖拽的左边
            columns = this.getViewColumns('all');
            visibleColumns = this.getViewColumns();
            rawColumns = rawColumns.filter(col =>
                col.visible && !viewMap[col.key]?.visible && !hiddenLeftItem?.includes(col.key),
            );
            startCol = rawColumns[leftDragIndex];
            startColIndex = viewMap[startCol.attrcode]._index;
            endCol = visibleColumns[destinationIndex];
            endColIndex = endCol._index;
            this.moveColumns(startColIndex, endColIndex, "insert");
            viewMap[startCol.attrcode].visible = true;
            this.setState({ viewMap });
        } else {
            if (rightDragIndex === destinationIndex) { return; }
            columns = this.getViewColumns();
            startCol = columns[rightDragIndex];
            startColIndex = startCol._index;
            endCol = columns[destinationIndex];
            endColIndex = endCol._index;
            this.moveColumns(startColIndex, endColIndex);
        }

        //拖拽完恢复原始状态
        this.rightDragIndex = -1;
        this.leftDragIndex = -1;
    }

    handleReset = () => {
        const { store, onClose, locale } = this.props;
        let { tableId } = this.state;
        resetColumns(store, tableId).then(res => {
            if (res.success) {
                let { rawColumns } = this.state;

                // 清除localStorage里的列宽信息
                setLocalStorageColumnsWidth(store, tableId, null);

                this.setState({
                    viewColumnKeys: rawColumns.map((col, index) => {
                        col._index = index;
                        return col.key;
                    }),
                    viewMap: rawColumns.reduce((viewMap, col, index) => {
                        col._index = index;
                        // 列宽不重置
                        col.width = store.getColumnProps(col.key, 'width');
                        viewMap[col.key] = { islock: false, resizable: true, ...col };
                        return viewMap;
                    }, {}),
                }, this.updatePropColumns);
                toast({ content: locale['column_reset_success'] /*列设置重置成功*/, light: true });
                onClose?.();
            }
        });

    }

    handleSave = (toastTip, toastLight) => {
        let visibleColumns = this.getViewColumns();
        const { store, onClose, locale, onSave } = this.props;

        if (!visibleColumns.length) {
            toast({ content: locale['table_colseting_tip15'] /* 请至少保留一个字段 */, color: 'warning' });
            return;
        }

        let { viewColumnKeys, viewMap, tableId } = this.state,
            lockColumns = [],
            normalColumns = [];

        viewColumnKeys.forEach(key => {
            let col = viewMap[key];
            if (col.islock) {
                lockColumns.push(col);
            } else {
                normalColumns.push(col);
            }
        });

        let reqColumns = lockColumns.concat(normalColumns).map(col => ({ ...col, width: col.width === 'undefined' ? '' : col.width }));

        setColumns(store, tableId, reqColumns).then(res => {
            if (res.success) {
                this.updatePropColumns();
                toast({ content: locale[toastTip] /*列设置保存成功/冻结成功/隐藏成功*/, light: toastLight });
                onClose?.();
            }
        });

        onSave?.();
    }

    // 计算剩余宽度，确定可以锁定（固定列）的个数
    getMaxLockColumnIndex = () => {
        let { tableBody, store } = this.props,
            viewColumns = this.getViewColumns(),
            maxIndex = viewColumns.length - 1;

        let { left, right } = getViewportBoundary(tableBody),
            scrollWidth = right - left;

        // scrollWidth不包含已经锁定的列，先把已经锁定的列的宽度加上，得到真正的视口宽度
        for (let i = 0, l = viewColumns.length; i < l; i++) {
            if (store.getColumnProps(viewColumns[i].key, 'islock')) {
                scrollWidth += Number(viewColumns[i].width);
            }
        }

        // 再算maxIndex
        for (let i = 0, l = viewColumns.length, totalWidth = 0; i < l; i++) {
            totalWidth += Number(viewColumns[i].width);
            if (totalWidth > scrollWidth) {
                maxIndex = i - 1;
                break;
            }
        }

        return Math.max(0, maxIndex);
    }

    // dataIndex
    moveColumns = (startIndex, endIndex, type) => {
        const { viewColumnKeys, viewMap } = this.state;

        let temp = viewColumnKeys[startIndex];

        if (startIndex < endIndex) {
            // 插入逻辑是插入到endIndex的前面，所以endIndex要-1，否则此分支会插入到endIndex的后边
            type === "insert" && endIndex--;
            for (
                let i = startIndex + 1;
                i <= endIndex;
                i++
            ) {
                viewColumnKeys[i - 1] = viewColumnKeys[i];
                viewMap[viewColumnKeys[i - 1]]._index = i - 1;
            }
        } else {
            for (
                let i = startIndex - 1;
                i >= endIndex;
                i--
            ) {
                viewColumnKeys[i + 1] = viewColumnKeys[i];
                viewMap[viewColumnKeys[i + 1]]._index = i + 1;
            }
        }

        viewColumnKeys[endIndex] = temp;
        viewMap[viewColumnKeys[endIndex]]._index = endIndex;

        this.setState({ viewColumnKeys, viewMap });
    }

    insertColumns = (startIndex, endIndex) => {
        const { viewColumnKeys, viewMap } = this.state;

        let temp = viewColumnKeys[startIndex];

        if (startIndex < endIndex) {

            for (
                let i = startIndex + 1;
                i <= endIndex - 1;
                i++
            ) {
                viewColumnKeys[i - 1] = viewColumnKeys[i];
                viewMap[viewColumnKeys[i - 1]]._index = i - 1;
            }
        } else {
            for (
                let i = startIndex - 1;
                i >= endIndex;
                i--
            ) {
                viewColumnKeys[i + 1] = viewColumnKeys[i];
                viewMap[viewColumnKeys[i + 1]]._index = i + 1;
            }
        }

        viewColumnKeys[endIndex] = temp;
        viewMap[viewColumnKeys[endIndex]]._index = endIndex;

        this.setState({ viewColumnKeys, viewMap });
    }

    getViewColumns = (range = 'visible') => {
        let { hiddenLeftItem } = this.props,
            { viewColumnKeys, viewMap } = this.state;
        return viewColumnKeys.map(key => viewMap[key]).filter(col => {
            if (range === "visible") {
                return col.visible && !hiddenLeftItem?.includes(col.key);
            } else if (range === "all") {
                return true;
            }
        },
        );
    }
}

export default ColSetting;